// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"e8da5b19","503":"3925a8a3","612":"53e416f6","683":"3f30f7a9"}[chunkId] + ".chunk.js";
};